module.exports = __webpack_public_path__ + "img/IMG_8565.a59d83d9.jpg";